export { default } from '@uhg-abyss/core/next-app';
